import { call, put, takeLatest } from 'redux-saga/effects';
import * as api from '../../api/stream';
import * as constants from './constants';
import * as authConstants from '../auth/constants';
import { actionStatus, getError, statusAction } from '../utils';
import { generateId } from '../../helpers/utils';
import { addNotification } from '../ui/notifications/actions';
import { NOTIFICATION_TYPE_INTERACTION } from '../../attrs/notifications';
import { cleanupOpenWebsocketConnections } from './websocket';
import { currentSession, irisEnabled } from '../../auth/iris';

function* handleWebsocketsCleanup({ localOnly = false } = {}) {
  try {
    cleanupOpenWebsocketConnections();
    if (localOnly) return;
    yield call([localStorage, 'removeItem'], 'websocketToken');
    yield call([localStorage, 'removeItem'], 'loadingWebsocketTokenLock');
  } catch (error) {
    yield put(
      addNotification({
        key: generateId(),
        type: actionStatus.ERROR,
        message: `Error during websocket cleanup: ${error.message}`,
        notificationType: NOTIFICATION_TYPE_INTERACTION
      })
    );
  }
}

function* handleLoadWebsocketToken() {
  try {
    const { data } = yield call(api.getWebsocketToken);
    yield call([localStorage, 'setItem'], 'websocketToken', data.token);
    yield put(statusAction(constants.LOAD_WEBSOCKET_TOKEN, actionStatus.SUCCESS, { payload: data }));
  } catch (err) {
    const error = getError(err);
    yield put(
      statusAction(constants.LOAD_WEBSOCKET_TOKEN, actionStatus.ERROR, {
        message: error
      })
    );

    yield put(
      addNotification({
        key: generateId(),
        type: actionStatus.ERROR,
        message: `errors.stream.${error}`,
        notificationType: NOTIFICATION_TYPE_INTERACTION
      })
    );
  }
}

function* handleWebsockets({ value: isAuthenticated, localOnly = false }) {
  yield call(handleWebsocketsCleanup, { localOnly });
  if (isAuthenticated) {
    if (!irisEnabled) yield call(handleLoadWebsocketToken);
    else if (currentSession())
      yield put(statusAction(constants.LOAD_WEBSOCKET_TOKEN, actionStatus.SUCCESS, { payload: null }));
  }
}

export function* watchLoadOrders() {
  yield takeLatest(authConstants.SET_AUTHENTICATION, handleWebsockets);
  yield takeLatest(constants.CLEANUP_WEBSOCKETS, handleWebsocketsCleanup);
}
